import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import * as stripePriceProductReducer from './reducers/stripe-price-product.reducer';
import { StripePriceProductEffects } from './effects/stripe-price-product.effects';
import { StoreModule } from '@ngrx/store';
import { StripePriceProductService } from './services/stripe-price-product.service';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(
      stripePriceProductReducer.stripePriceProductsFeatureKey,
      stripePriceProductReducer.reducer
    ),
    EffectsModule.forFeature([StripePriceProductEffects]),
  ],
  providers: [StripePriceProductService],
})
export class StripePriceProductsStoreModule {}
